import { React, useState, useEffect } from 'react';
import Select from 'react-select';
import LeaseApiService from '../../services/apiService';
import { AsyncPaginate } from 'react-select-async-paginate';

const MasterDetails = ({
  tableLoading,
  setTransectionData,
  bedRoomList,
  setunitCategoryList,
  setcommunityList,
  setCityList,
  setFeaturesList,
  transectionData,
  countriesList,
  cityList,
  propertyList,
  salersList,
  landlordList,
  communityList,
  unitTypeList,
  unitViewList,
  unitCategoryList,
  floorList,
}) => {
  const apiService = new LeaseApiService();
  const ITEMS_PER_PAGE = 100;

  const handleInputChange = (input) => {
    const name = input?.target?.name || input.name;
    const value = input?.target?.value || input.value;

    setTransectionData((prev) => {
      const updatedData = { ...prev, [name]: value };
      return updatedData;
    });
  };
  const handleDropDownChange = async ({ name, value }) => {
    if (name === 'property') {
      const scndparams = new URLSearchParams();
      scndparams.append('Action', 'GetUnitfeatuersByPropertyNo');
      scndparams.append('PropertyNo', value?.value?.value);
      const scndRes = await apiService.getApiParamater('GET_UNIT_COMMON', `?${scndparams.toString()}`);
      setFeaturesList(scndRes?.data?.result?.data);

      const countParam = new URLSearchParams();
      countParam.append('Action', 'UMCountryCityByPropertyNo');
      countParam.append('PropertyNo', transectionData?.property?.value?.value);
      const cntryRes = await apiService.getApiParamater('GET_UNIT_COMMON', `?${countParam.toString()}`);
      const duplicateCheck = cntryRes?.data?.result?.data;
      setTransectionData((prev) => ({
        ...prev,
        country: { label: duplicateCheck?.Country, value: duplicateCheck?.Country },
        city: { label: duplicateCheck?.City, value: duplicateCheck?.City },
        [name]: value,
      }));
    } else if (name === 'country') {
      if (!value?.label) {
        setCityList([]);
        setcommunityList([]);
        setTransectionData((prev) => ({
          ...prev,
          country: null,
          city: null,
          community: null,
        }));
        return;
      }
      const scndparams = new URLSearchParams();
      scndparams.append('DropdownFor', 'UMCitiesByCountry');
      scndparams.append('CascadValue', value?.label);
      const scndRes = await apiService.getApiParamater('GET_UNIT_CASCAD', `?${scndparams.toString()}`);
      setCityList(scndRes?.data?.items || []);
      const comParam = new URLSearchParams();
      comParam.append('DropdownFor', 'UMCommunitiesByCountryCity');
      comParam.append('CascadValue', value?.label);
      const commRes = await apiService.getApiParamater('GET_UNIT_CASCAD', `?${comParam.toString()}`);
      setcommunityList(commRes?.data?.items || []);
      setTransectionData((prev) => ({
        ...prev,
        country: value,
        city: null,
        community: null,
      }));
      return;
    } else if (name === 'city') {
      const comParam = new URLSearchParams();
      comParam.append('DropdownFor', 'UMCommunitiesByCountryCity');
      comParam.append('CascadValue', transectionData?.country?.label);
      comParam.append('CascadText', value?.label);
      const commRes = await apiService.getApiParamater('GET_UNIT_CASCAD', `?${comParam.toString()}`);
      setcommunityList(commRes?.data?.items || []);
      setTransectionData((prev) => ({
        ...prev,
        city: value,
        community: null,
      }));
      return;
    } else if (name === 'unitType') {
      const comParam = new URLSearchParams();
      comParam.append('DropdownFor', 'UMUnitCategoriesByType');
      comParam.append('CascadValue', value?.label);
      const commRes = await apiService.getApiParamater('GET_UNIT_CASCAD', `?${comParam.toString()}`);
      setunitCategoryList(commRes?.data?.items);
    }
    setTransectionData((prev) => ({ ...prev, [name]: value }));
  };
  const loadOptionsName = (search, loadedOptions, { page }) => {
    let filtered = landlordList;

    if (search) {
      filtered = landlordList.filter(
        (tenant) => tenant.value.toLowerCase().includes(search.toLowerCase()) || tenant.text.toLowerCase().includes(search.toLowerCase()),
      );
    }

    const start = page * ITEMS_PER_PAGE;
    const end = start + ITEMS_PER_PAGE;

    const optionsChunk = filtered.slice(start, end);

    return Promise.resolve({
      options: optionsChunk.map((tenant) => ({ value: tenant?.value, label: tenant.text })),
      hasMore: end < filtered.length,
      additional: { page: page + 1 },
    });
  };
  return (
    <div className="cost-center-section my-3">
      <div className={`border-box2 p-3`}>
        {tableLoading && (
          <div
            style={{
              position: 'absolute',
              inset: 0,
              background: 'rgba(255,255,255,0.6)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 10,
            }}
          >
            <div className="spinner-border text-primary" role="status" />
          </div>
        )}
        <div className="form-group" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(340px, 1fr))', gap: '20px' }}>
          <div className="d-flex">
            <label htmlFor="validationCustom01" className="form-label pt-1 start">
              Resale
            </label>
            <input
              className="form-check-input"
              type="checkbox"
              id="resale"
              style={{ width: '20px', height: '20px' }}
              checked={transectionData.resale}
              onChange={(e) => setTransectionData((prev) => ({ ...prev, resale: e.target.checked }))}
            />
          </div>
          <div></div>
          <div></div>
          <div className="d-flex">
            <label htmlFor="validationCustom18" className="form-label">
              Country
            </label>
            <Select
              className="p-0 w-100"
              theme={(theme) => ({
                ...theme,
                borderRadius: 5,
                padding: 9,
              })}
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                option: (provided, state) => ({
                  ...provided,
                  backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                  color: state.isFocused ? '#000 ' : '#000',
                  ':hover': {
                    backgroundColor: '#F5F5F5',
                    color: '#000 ',
                  },
                }),
              }}
              value={transectionData?.country}
              onChange={(selectedOption) => handleDropDownChange({ name: 'country', value: selectedOption })}
              options={countriesList?.map((country) => ({ value: country, label: country?.text }))}
            />
          </div>
          <div className="d-flex">
            <label htmlFor="validationCustom18" className="form-label">
              Saller/Landlord
            </label>
            <AsyncPaginate
              className="p-0 w-100"
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                option: (provided, state) => ({
                  ...provided,
                  backgroundColor: state.isFocused ? '#F5F5F5' : null,
                  color: '#000',
                  ':hover': { backgroundColor: '#F5F5F5', color: '#000' },
                }),
              }}
              loadOptions={loadOptionsName}
              defaultOptions
              value={transectionData?.saller}
              onChange={(selectedOption) => handleDropDownChange({ name: 'saller', value: selectedOption })}
              additional={{ page: 0 }}
            />
          </div>
          <div className="d-flex">
            <label htmlFor="validationCustom18" className="form-label">
              Property *
            </label>
            <Select
              className="p-0 w-100"
              theme={(theme) => ({
                ...theme,
                borderRadius: 5,
                padding: 9,
              })}
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                option: (provided, state) => ({
                  ...provided,
                  backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                  color: state.isFocused ? '#000 ' : '#000',
                  ':hover': {
                    backgroundColor: '#F5F5F5',
                    color: '#000 ',
                  },
                }),
              }}
              value={transectionData?.property}
              onChange={(selectedOption) => handleDropDownChange({ name: 'property', value: selectedOption })}
              options={propertyList?.map((country) => ({ value: country, label: country?.text }))}
            />
          </div>
          <div className="d-flex">
            <label htmlFor="validationCustom22" className="form-label">
              City
            </label>
            <Select
              className="p-0 w-100"
              theme={(theme) => ({
                ...theme,
                borderRadius: 5,
                padding: 9,
              })}
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                option: (provided, state) => ({
                  ...provided,
                  backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                  color: state.isFocused ? '#000 ' : '#000',
                  ':hover': {
                    backgroundColor: '#F5F5F5',
                    color: '#000 ',
                  },
                }),
              }}
              value={transectionData?.city}
              onChange={(selectedOption) => handleDropDownChange({ name: 'city', value: selectedOption })}
              options={cityList?.map((country) => ({ value: country, label: country?.text }))}
            />
          </div>
          <div className="d-flex">
            <label htmlFor="validationCustom18" className="form-label">
              Saller/Landlord Id
            </label>
            <Select
              className="p-0 w-100"
              theme={(theme) => ({
                ...theme,
                borderRadius: 5,
                padding: 9,
              })}
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                option: (provided, state) => ({
                  ...provided,
                  backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                  color: state.isFocused ? '#000 ' : '#000',
                  ':hover': {
                    backgroundColor: '#F5F5F5',
                    color: '#000 ',
                  },
                }),
              }}
              value={transectionData?.landlordId}
              onChange={(selectedOption) => handleDropDownChange({ name: 'landlordId', value: selectedOption })}
              options={landlordList?.map((country) => ({ value: country, label: country?.text }))}
            />
          </div>
          <div className="d-flex">
            <label htmlFor="validationCustom01" className="form-label pt-1 start">
              {' '}
              Unit No *
            </label>
            <input type="text" className="p-2 form-control w-75" value={transectionData?.unitNo} onChange={handleInputChange} name="unitNo" />
          </div>
          <div className="d-flex">
            <label htmlFor="validationCustom22" className="form-label">
              Community
            </label>
            <Select
              className="p-0 w-100"
              theme={(theme) => ({
                ...theme,
                borderRadius: 5,
                padding: 9,
              })}
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                option: (provided, state) => ({
                  ...provided,
                  backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                  color: state.isFocused ? '#000 ' : '#000',
                  ':hover': {
                    backgroundColor: '#F5F5F5',
                    color: '#000 ',
                  },
                }),
              }}
              value={transectionData?.community}
              onChange={(selectedOption) => handleDropDownChange({ name: 'community', value: selectedOption })}
              options={communityList?.map((country) => ({ value: country, label: country?.text }))}
            />
          </div>
          <div className="d-flex">
            <label htmlFor="validationCustom01" className="form-label pt-1 start">
              Municipality Ac No{' '}
            </label>
            <input type="text" className="p-2 form-control w-75" value={transectionData?.municipltyNo} onChange={handleInputChange} name="municipltyNo" />
          </div>
          <div className="d-flex">
            <label htmlFor="validationCustom01" className="form-label pt-1 start">
              Ref No{' '}
            </label>
            <input type="text" className="p-2 form-control w-75" disabled value={transectionData?.refNo} onChange={handleInputChange} name="refNo" />
          </div>
          <div className="d-flex">
            <label htmlFor="validationCustom01" className="form-label pt-1 start">
              Unit Class *
            </label>
            <input type="text" className="p-2 form-control w-75" value={transectionData?.unitClass} onChange={handleInputChange} name="unitClass" />
          </div>
          <div className="d-flex">
            <label htmlFor="validationCustom01" className="form-label pt-1 start">
              Sector{' '}
            </label>
            <input type="text" className="p-2 form-control w-75" value={transectionData?.sector} onChange={handleInputChange} name="sector" />
          </div>
          <div className="d-flex">
            <label htmlFor="validationCustom01" className="form-label pt-1 start">
              Block
            </label>
            <input type="text" className="p-2 form-control w-75" value={transectionData?.block} onChange={handleInputChange} name="block" />
          </div>
          <div className="d-flex">
            <label htmlFor="validationCustom22" className="form-label">
              Unit Type *
            </label>
            <Select
              className="p-0 w-100"
              theme={(theme) => ({
                ...theme,
                borderRadius: 5,
                padding: 9,
              })}
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                option: (provided, state) => ({
                  ...provided,
                  backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                  color: state.isFocused ? '#000 ' : '#000',
                  ':hover': {
                    backgroundColor: '#F5F5F5',
                    color: '#000 ',
                  },
                }),
              }}
              value={transectionData?.unitType}
              onChange={(selectedOption) => handleDropDownChange({ name: 'unitType', value: selectedOption })}
              options={unitTypeList?.map((country) => ({ value: country, label: country?.text }))}
            />
          </div>
          <div className="d-flex">
            <label htmlFor="validationCustom01" className="form-label pt-1 start">
              BathRoom
            </label>
            <input type="text" className="p-2 form-control w-75" value={transectionData?.bathRoom} onChange={handleInputChange} name="bathRoom" />
          </div>
          <div className="d-flex">
            <label htmlFor="validationCustom01" className="form-label pt-1 start">
              Balcony Area
            </label>
            <input type="email" className="p-2 form-control w-75" value={transectionData?.balcony} onChange={handleInputChange} name="balcony" />
          </div>
          <div className="d-flex">
            <label htmlFor="validationCustom01" className="form-label pt-1 start">
              Unit Category *
            </label>
            <Select
              className="p-0 w-100"
              theme={(theme) => ({
                ...theme,
                borderRadius: 5,
                padding: 9,
              })}
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                option: (provided, state) => ({
                  ...provided,
                  backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                  color: state.isFocused ? '#000 ' : '#000',
                  ':hover': {
                    backgroundColor: '#F5F5F5',
                    color: '#000 ',
                  },
                }),
              }}
              value={transectionData?.unitCategory}
              onChange={(selectedOption) => handleDropDownChange({ name: 'unitCategory', value: selectedOption })}
              options={unitCategoryList?.map((country) => ({ value: country, label: country?.text }))}
            />
          </div>
          <div className="d-flex">
            <label htmlFor="validationCustom01" className="form-label pt-1 start">
              Living Area
            </label>
            <input type="text" className="p-2 form-control w-75" value={transectionData?.livingarea} onChange={handleInputChange} name="livingarea" />
          </div>
          <div className="d-flex">
            <label htmlFor="validationCustom01" className="form-label pt-1 start">
              Terrace Area
            </label>
            <input type="text" className="p-2 form-control w-75" value={transectionData?.terraceArea} onChange={handleInputChange} name="terraceArea" />
          </div>
          <div className="d-flex">
            <label htmlFor="validationCustom01" className="form-label pt-1 start">
              Unit View *
            </label>
            <Select
              className="p-0 w-100"
              theme={(theme) => ({
                ...theme,
                borderRadius: 5,
                padding: 9,
              })}
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                option: (provided, state) => ({
                  ...provided,
                  backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                  color: state.isFocused ? '#000 ' : '#000',
                  ':hover': {
                    backgroundColor: '#F5F5F5',
                    color: '#000 ',
                  },
                }),
              }}
              value={transectionData?.unitView}
              onChange={(selectedOption) => handleDropDownChange({ name: 'unitView', value: selectedOption })}
              options={unitViewList?.map((country) => ({ value: country, label: country?.text }))}
            />
          </div>
          <div className="d-flex">
            <label htmlFor="validationCustom01" className="form-label pt-1 start">
              Total Area *
            </label>
            <input type="text" className="p-2 form-control w-75" value={transectionData?.totalArea} onChange={handleInputChange} name="totalArea" />
            <label htmlFor="validationCustom01" className="form-label pt-1 center">
              Sq M
            </label>
          </div>
          <div className="d-flex">
            <label htmlFor="validationCustom01" className="form-label pt-1 start">
              Net Area
            </label>
            <input type="text" className="p-2 form-control w-75" value={transectionData?.netArea} onChange={handleInputChange} name="netArea" />
          </div>
          <div className="d-flex">
            <label htmlFor="validationCustom01" className="form-label pt-1 start">
              Floor
            </label>
            <Select
              className="p-0 w-100"
              theme={(theme) => ({
                ...theme,
                borderRadius: 5,
                padding: 9,
              })}
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                option: (provided, state) => ({
                  ...provided,
                  backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                  color: state.isFocused ? '#000 ' : '#000',
                  ':hover': {
                    backgroundColor: '#F5F5F5',
                    color: '#000 ',
                  },
                }),
              }}
              value={transectionData?.floor}
              onChange={(selectedOption) => handleDropDownChange({ name: 'floor', value: selectedOption })}
              options={floorList?.map((country) => ({ value: country, label: country?.text }))}
            />
          </div>
          <div className="d-flex">
            <label htmlFor="validationCustom01" className="form-label pt-1 start">
              No of Parkings
            </label>
            <input type="text" className="p-2 form-control w-75" value={transectionData?.parking} onChange={handleInputChange} name="parking" />
          </div>
          <div className="d-flex">
            <label htmlFor="validationCustom01" className="form-label pt-1 start">
              Unit Rate
            </label>
            <input type="text" className="p-2 form-control w-75" value={transectionData?.unitRate} onChange={handleInputChange} name="unitRate" />
          </div>
          <div className="d-flex">
            <label htmlFor="validationCustom01" className="form-label pt-1 start">
              Remarks
            </label>
            <textarea type="text" className="p-2 form-control w-75" value={transectionData?.remarks} onChange={handleInputChange} name="remarks" />
          </div>
          <div className="d-flex">
            <label htmlFor="validationCustom01" className="form-label pt-1 start">
              BedRooms *
            </label>
            <Select
              className="p-0 w-100"
              theme={(theme) => ({
                ...theme,
                borderRadius: 5,
                padding: 9,
              })}
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                option: (provided, state) => ({
                  ...provided,
                  backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                  color: state.isFocused ? '#000 ' : '#000',
                  ':hover': {
                    backgroundColor: '#F5F5F5',
                    color: '#000 ',
                  },
                }),
              }}
              value={transectionData?.bedRooms}
              onChange={(selectedOption) => handleDropDownChange({ name: 'bedRooms', value: selectedOption })}
              options={bedRoomList?.map((country) => ({ value: country, label: country?.text }))}
            />
          </div>
          <div className="d-flex">
            <label htmlFor="validationCustom01" className="form-label pt-1 start">
              Parking Price
            </label>
            <input type="text" className="p-2 form-control w-75" value={transectionData?.parkingPrice} onChange={handleInputChange} name="parkingPrice" />
          </div>
        </div>
      </div>
    </div>
  );
};
export default MasterDetails;
